import { useEditStore } from '../../store/edit-store';
import type { EditStore } from '../../types/edit-store';

/**
 * @deprecated Use `useEditStore` instead
 */
export const useEditContext = (): EditStore => {
  return useEditStore();
};
